import { NAV_BAR_ID } from "app/partials/NavBar/NavBar";
import cx from "classnames";
import type { Element, Node } from "React";
import { Component } from "react";
import { Link } from "react-router-dom";
import { Link as AnchorLink } from "react-scroll";
import { $Values } from "utility-types";
import "./Button.scss";

/**
 * Enum with all the button types.
 * @readonly
 * @enum {string}
 */
const ButtonType = Object.freeze({
  PRIMARY: "primary",
  SECONDARY: "secondary",
});
type Props = {
  /** Class name attached with the button component */
  className?: any;

  /** Type of the button ex- Primary or Secondary */
  type: $Values<typeof ButtonType>;

  /** Navigation link associated with the button */
  to?: string;

  /** The content rendered inside the button */
  children: any;

  /** Callback when user clicks the button */
  onClick?: (...args: Array<any>) => any;

  /** Anchor link with scroll animation to element */
  anchorTo?: string;
};
type State = {
  navBarHeight: number;
};
/**
 * Custom button
 * * Primary type: solid bg color
 * * Secondary type: transparent bg color
 */

class Button extends Component<Props, State> {
  static defaultProps: {
    type: any;
  } = {
    type: ButtonType.PRIMARY,
  };
  state: State = {
    navBarHeight: 0,
  };

  componentDidMount() {
    // If anchor link is passed in
    // then find the Nav bar element
    // to calculate the height
    if (this.props.anchorTo) {
      const navBarElement = document && document.getElementById(NAV_BAR_ID);

      if (navBarElement && navBarElement.clientHeight) {
        const navBarHeight = navBarElement.clientHeight;
        this.setState({
          navBarHeight,
        });
      }
    }
  }

  render(): Node | Element<"button"> {
    let { className, type, children, onClick, to, anchorTo } = this.props;
    const button = (
      <button
        className={cx("button", className, {
          "button--primary": type === ButtonType.PRIMARY,
          "button--secondary": type === ButtonType.SECONDARY,
        })}
        onClick={onClick}
      >
        {children}
      </button>
    );

    if (anchorTo) {
      return (
        <AnchorLink
          smooth={true}
          offset={-this.state.navBarHeight}
          to={anchorTo}
        >
          {button}
        </AnchorLink>
      );
    }

    return to ? <Link to={to}>{button}</Link> : button;
  }
}

export default Button;
export { ButtonType };
